/**
 * Local stand-in rewrites for Atlas vault fixtures.
 * Vault paths → site-relative art so partykit dev can prove the push
 * without Dropbox/CDN. Production pushes should pass real HTTP art URLs via
 * assetBaseUrl / explicit rewrites instead.
 */

export const ATLAS_LINK_TEST_REWRITES: Record<string, string> = {
  "atlas-vtt/assets/MarshesWithTree_1790645893659_pyzx8r.webp":
    "/demo-adventure/map.svg",
  "atlas-vtt/assets/katari_ranger_beastbound_f_s6_linktest.png":
    "/demo-adventure/token-rowan.svg",
  "atlas-vtt/assets/goblin_locked_s6_linktest.png":
    "/demo-adventure/token-ember.svg",
};

export const ATLAS_LINK_TEST_URL = "/atlas-export/atlas-link-test.atlasmap";

/** PortSmokeTest: real Marshes map + PC/adversary plates mirrored in-repo. */
export const PORT_SMOKE_REWRITES: Record<string, string> = {
  "atlas-vtt/assets/MarshesWithTree_1790645893659_pyzx8r.webp":
    "/atlas-export/port-smoke/marshes.webp",
  "atlas-vtt/assets/faerie_sorcerer_elemental_f_portsmoke.png":
    "/atlas-export/port-smoke/faerie.png",
  "atlas-vtt/assets/goblin_locked_portsmoke.png":
    "/atlas-export/port-smoke/goblin.png",
  "atlas-vtt/assets/assassin_portsmoke.webp":
    "/atlas-export/port-smoke/assassin.webp",
};

export const PORT_SMOKE_URL = "/atlas-export/port-smoke-test.atlasmap";

/** Native map size for MarshesWithTree.webp (used by PortSmokeTest push). */
export const PORT_SMOKE_MAP_WIDTH = 2048;
export const PORT_SMOKE_MAP_HEIGHT = 2048;

/** Combined rewrites for GM paste / file pick (Link Test + Port Smoke). */
export const ATLAS_LOCAL_REWRITES: Record<string, string> = {
  ...ATLAS_LINK_TEST_REWRITES,
  ...PORT_SMOKE_REWRITES,
};
